import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "employee/exam"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getAllExams() {
        return http.list(path + "/getAll");
    }


}

export default new service();

